export const downloadCSVFile = (data) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', 'download.csv');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const dataToCSV = (data) => {
  const {
    parse,
    transforms: { unwind, flatten },
  } = require('json2csv');
  const fields = [
    { label: 'ID', value: `id` },
    { label: 'Imię', value: `name` },
    { label: 'Nazwisko', value: `surname` },
    { label: 'PESEL', value: `pesel` },
    { label: 'Rok', value: `year` },
    {
      label: 'Data przesłania',
      value: (row) => (row.uploadDate ? row.uploadDate.join('.') : null),
    },
    { label: 'Powierzchnia pól', value: `fieldsArea` },
    { label: 'Wartość produkcji', value: `productionValue` },
    {
      label: 'Potencjalna wartość produkcji',
      value: `potentialProductionValue`,
    },
    { label: 'Nazwa uprawy', value: `groupedCultivationsList.cropName` },
    { label: 'Powierzchnia uprawy', value: `groupedCultivationsList.cropArea` },
    {
      label: 'Zoptymalizowana powierzchnia uprawy',
      value: `groupedCultivationsList.optimalizedCropArea`,
    },
    { label: 'Pole', value: `directPaymentFields.id` },
    { label: 'Teryt pola', value: `directPaymentFields.teryt` },
    { label: 'Powierzchnia', value: `directPaymentFields.areaNumber` },
    { label: 'Numer pola', value: `directPaymentFields.fieldNumber` },
    {
      label: 'Zakwalifikowana powierzchnia',
      value: `directPaymentFields.qualifiedArea`,
    },
    { label: 'ID uprawy', value: `cultivationsList.id` },
    { label: 'Nazwa', value: `cultivationsList.cropName` },
    { label: 'Powierzchnia uprawy', value: `cultivationsList.cropArea` },
    { label: 'Grupa przychodowa', value: `cultivationsList.cropIncomeGroup` },
    {
      label: 'Grupa środowiskowa',
      value: `cultivationsList.cropEnvironmentalGroup`,
    },
    {
      label: 'Zoptymalizowana powierzchnia uprawy',
      value: `cultivationsList.optimalizedCropArea`,
    },
    {
      label: 'Indeks przychodu uprawy',
      value: `cultivationsList.cropIncomeIndex`,
    },
    { label: 'Nazwa uprawy', value: `cultivationsList.cultivationName` },
    { label: 'ID płatności', value: `cultivationsList.paymentType.id` },
    { label: 'Typ płatności', value: `cultivationsList.paymentType.packet` },
    {
      label: 'Opis płatności',
      value: `cultivationsList.paymentType.packetDescription`,
    },
  ];
  const opts = {
    fields,
    transforms: [
      unwind({
        paths: [
          'groupedCultivationsList',
          'directPaymentFields',
          'cultivationsList',
        ],
        blankOut: true,
      }),
      flatten({ objects: false, arrays: false }),
    ],
  };

  try {
    const csv = parse(data, opts);
    return csv;
  } catch (err) {}
};

export const cropsStructureTableToCSV = (data) => {
  const { parse } = require('json2csv');
  const fields = [
    { label: 'Nazwa', value: `name` },
    { label: 'Powierzchnia (ha)', value: `area` },
    { label: '% Powierzchni', value: `fieldPercent` },
  ];
  const opts = { fields };

  try {
    const csv = parse(data, opts);
    return csv;
  } catch (err) {}
};

export const subsidiesAmountTableToCSV = (data) => {
  const { parse } = require('json2csv');
  const fields = [
    { label: 'Nazwa dopłaty', value: `name` },
    {
      label: 'Łączna powierzchnia zakwalifikowana pod daną dopłatę (ha)',
      value: (row) => row.area.toFixed(2),
    },
    {
      label: 'Łączny dochód uzyskany z danego typu dopłaty (zł)',
      value: (row) => row.income.toFixed(2),
    },
    {
      label: '% Udziału zysku z danego typu dopłaty w gospodarstwie',
      value: (row) => row.percentageOfTotalIncome.toFixed(2),
    },
  ];
  const opts = { fields };

  try {
    const csv = parse(data, opts);
    return csv;
  } catch (err) {}
};

export const individualPlotsCropsTableToCSV = (data) => {
  const {
    parse,
    transforms: { unwind, flatten },
  } = require('json2csv');
  const fields = [
    { label: 'Nazwa uprawy', value: `cropName` },
    { label: 'Powierzchnia (ha)', value: `area` },
    { label: 'Suma dochodów z dopłat (zł)', value: `paymentIncome` },
    { label: 'Numer teryt', value: `terytList.identificationNumber` },
    {
      label: 'Powierzchnia (ha)',
      value: `terytList.area`,
    },
    {
      label: 'Suma dochodów z dopłat (zł)',
      value: `terytList.paymentIncome`,
    },
  ];
  const opts = {
    fields,
    transforms: [
      unwind({ paths: ['terytList'], blankOut: true }),
      flatten({ objects: true, arrays: false }),
    ],
  };

  try {
    const csv = parse(data, opts);
    return csv;
  } catch (err) {}
};

export const plotsOwnershipTableToCSV = (data) => {
  const { parse } = require('json2csv');
  const fields = [
    { label: 'Numer teryt', value: `teryt` },
    {
      label: 'Powierzchnia (ha)',
      value: (row) => row.area.toFixed(2),
    },
    {
      label: 'Forma użytkowania gruntu',
      value: (row) => (row.owned ? 'Własność' : 'Dzierżawa'),
    },
  ];
  const opts = { fields };

  try {
    const csv = parse(data, opts);
    return csv;
  } catch (err) {}
};
